// extracted by mini-css-extract-plugin
export default {"container":"src-components-TableEmptyComponent-index-module_container--l3CAb"};